import { render, staticRenderFns } from "./UpdateOwnerDialog.vue?vue&type=template&id=7815f858&scoped=true&"
import script from "./UpdateOwnerDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateOwnerDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOwnerDialog.vue?vue&type=style&index=0&id=7815f858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815f858",
  null
  
)

export default component.exports